import {Enumify} from 'enumify';

class TabulatorOnRowClickAction extends Enumify {
  static FILTER_MAIN_TABLE = new TabulatorOnRowClickAction();
  static _ = this.closeEnum();
}

export default TabulatorOnRowClickAction;
